module.exports = __webpack_public_path__ + "static/media/warmup_revision.b0a85eb5.png";